var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          !_vm.esEdicion
                            ? _vm.closeModal(false)
                            : (_vm.dialogConfirmacionClose = true)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v(" Editar Movimiento ")]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _vm.esEdicion
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              attrs: {
                                depressed: "",
                                disabled: _vm.guardarAnulado
                              },
                              on: {
                                click: function($event) {
                                  return _vm.grabarEdicion()
                                }
                              }
                            },
                            [_vm._v("Guardar Cambios")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-tabs",
                          [
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "general"
                                  }
                                }
                              },
                              [_vm._v("General")]
                            ),
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "seriados"
                                  }
                                }
                              },
                              [_vm._v("Equipos Seriados")]
                            ),
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "noSeriados"
                                  }
                                }
                              },
                              [_vm._v("Equipos No Seriados")]
                            ),
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "sim"
                                  }
                                }
                              },
                              [_vm._v("SIM")]
                            )
                          ],
                          1
                        ),
                        _vm.step == "general"
                          ? _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c("EditarGeneral", {
                                  ref: "FormularioInformacionGeneral",
                                  attrs: {
                                    anuladoId: _vm.anuladoId,
                                    recibidoId: _vm.recibidoId,
                                    estado: _vm.estado,
                                    operaciones: _vm.operaciones,
                                    edited: _vm.data,
                                    destinos: _vm.destinos,
                                    estadoSelected: _vm.estadoSelected,
                                    cajaEdited: _vm.caja,
                                    despachos: _vm.despachos,
                                    despachoEdited: _vm.despacho,
                                    despachoIsEdit: _vm.despachoIsEdit,
                                    cajaIsEdit: _vm.cajaIsEdit
                                  },
                                  on: {
                                    despacho: function($event) {
                                      return _vm.guardarDespacho($event)
                                    },
                                    caja: function($event) {
                                      return _vm.guardarCaja($event)
                                    },
                                    estado: function($event) {
                                      return _vm.guardarEstado($event)
                                    },
                                    anularBoton: function($event) {
                                      return _vm.anularBoton($event)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.step == "seriados"
                          ? _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c("EditarTablaSeriados", {
                                  attrs: {
                                    mostrarSerie: true,
                                    codigo: _vm.data.movinumero
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.step == "noSeriados"
                          ? _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c("EditarTablaNoSeriados", {
                                  attrs: {
                                    mostrarNoSerie: true,
                                    codigo: _vm.data.movinumero
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.step == "sim"
                          ? _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c("EditarSim", {
                                  attrs: {
                                    mostrarSim: true,
                                    codigo: _vm.data.movinumero
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }